import React, { useState } from 'react';

/** A link shown as selectable text with a copy button (used for demo set-password / reset links). */
export default function CopyLink({ href, label = 'Copy link' }) {
  const [copied, setCopied] = useState(false);
  const absolute = href?.startsWith('http') ? href : `${window.location.origin}${href || ''}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(absolute);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard unavailable: the text is selectable */ }
  };
  return (
    <span className="d-inline-flex flex-wrap align-items-center gap-2" style={{ maxWidth: '100%' }}>
      <a href={href} className="small" style={{ wordBreak: 'break-all' }}>{absolute}</a>
      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={copy}>
        <i className={`fa ${copied ? 'fa-check' : 'fa-copy'} me-1`} aria-hidden="true" />{copied ? 'Copied' : label}
      </button>
    </span>
  );
}
